import { ThemeConfig } from "antd"

const baseConfig = {
  button: {
    autoInsertSpace: false,
  },
}

const baseTheme: Pick<ThemeConfig, "cssVar" | "components"> = {
  components: {
    Button: { primaryShadow: "0 2px 8px #00000026", borderRadius: 4, paddingInline: 39.5 },
    Menu: {},
    Radio: {
      colorPrimary: "#5968ad",
    },
    Checkbox: {
      colorPrimary: "#5968ad",
    },
    Form: {
      verticalLabelPadding: "0 0 5px",
      itemMarginBottom: 0,
    },
    Layout: {
      headerBg: "white",
      bodyBg: "#f5f7ff",
      footerBg: "white",
    },
    Progress: {
      defaultColor: "#1f2b63",
    },
    Pagination: {
      colorPrimary: "#5968ad",
      colorPrimaryHover: "#1f2b63",
    },
    Table: {
      headerBg: "#b7bbcd",
      rowHoverBg: "inherit",
      rowSelectedBg: "inherit",
      rowSelectedHoverBg: "inherit",
      headerSplitColor: "#d2daff",
      headerColor: "#1f2b63",
      headerSortHoverBg: "#b7bbcd",
      headerSortActiveBg: "#b7bbcd",
      bodySortBg: "inherit",
      colorIcon: "#5968ad",
    },
    Tabs: {
      itemColor: "#5968ad",
      itemActiveColor: "#1f2b63",
      horizontalItemPadding: "5px 0px",
    },
    Spin: {
      contentHeight: "unset",
      dotSize: 40,
      dotSizeLG: 40,
    },
  },
}

export const defaultThemeConfigs = Object.assign({}, baseConfig, {
  theme: Object.assign({}, baseTheme, {
    token: {
      colorPrimary: "#1f2b63",
      fontFamily: "Noto Sans JP",
      borderRadius: 2,
    },
    components: {
      ...baseTheme.components,
      Button: { ...baseTheme.components?.Button, colorLink: "#7683c0", colorLinkHover: "#7683c0" },
    },
  }),
})

export const signageThemeConfigs = Object.assign({}, baseConfig, {
  theme: Object.assign({}, baseTheme, {
    token: {
      colorPrimary: "#f42f25",
      fontFamily: "Noto Sans JP",
      borderRadius: 2,
      motion: false,
    },
  }),
  wave: { disabled: true },
})
